import { render, staticRenderFns } from "./ApprovalInfo.vue?vue&type=template&id=6e94c72e&scoped=true&"
import script from "./ApprovalInfo.vue?vue&type=script&lang=js&"
export * from "./ApprovalInfo.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalInfo.vue?vue&type=style&index=0&id=6e94c72e&scoped=true&lang=less&"
import style1 from "./ApprovalInfo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e94c72e",
  null
  
)

export default component.exports